import { styled } from 'styled-components';

import devices from '../../../../../styles/devices';

// The entire list
export const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-tiny);
  overflow-y: auto;

  @media ${devices.tabletS} {
    max-height: var(--preference-compose-list-height);
    padding-inline: var(--spacing-big);
  }
`;
